import { AnalyticsEventName } from './constants';
import { trackEvent } from './utils';

export interface NonPromoEvent {
  block_name?: string;
  block_type?: string;
  block_id?: string;
}

export const trackViewEditorialEvent = (nonPromo: NonPromoEvent) => {
  if (nonPromo) {
    trackEvent({
      eventName: AnalyticsEventName.ViewEditorial,
      parameters: {
        block_name: nonPromo.block_name ?? '',
        block_type: nonPromo.block_type ?? '',
        block_id: nonPromo.block_id ?? ''
      }
    });
  }
};

export const trackSelectEditorialEvent = (nonPromo: NonPromoEvent) => {
  if (nonPromo) {
    trackEvent({
      eventName: AnalyticsEventName.SelectEditorial,
      parameters: {
        block_name: nonPromo.block_name ?? '',
        block_type: nonPromo.block_type ?? '',
        block_id: nonPromo.block_id ?? ''
      }
    });
  }
};
